/**
 * Kiddoware Laravel API base.
 * - Dev (`npm run dev`): `/kw-api/*` → Vite proxy → Laravel (see vite.config.js).
 * - Production build: absolute URL from VITE_KW_API_* (CORS on kw_backend_new).
 *   Static hosts (Amplify) often lack `/kw-api` rewrites; direct API avoids 404.
 */
export const KW_API_BROWSER_PREFIX = '/kw-api';

const DEFAULT_API_PATH = '/kw_backend_new/public';

function normalizePathSegment(path) {
  return String(path || '').replace(/^\/+/, '').replace(/\/+$/, '');
}

function getKwApiPath() {
  return (import.meta.env.VITE_KW_API_PATH || DEFAULT_API_PATH).replace(/\/+$/, '');
}

/** API origin for production cross-origin calls (no trailing slash). */
export function getKwApiOrigin() {
  const fromEnv = (import.meta.env.VITE_KW_API_ORIGIN || '').replace(/\/+$/, '');
  if (fromEnv) {
    return fromEnv;
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (host === 'explore-dev.kiddoware.com' || host === 'explore.dev.kiddoware.com') {
      return 'https://qa.app.kiddoware.com';
    }
  }
  return 'https://app.kiddoware.com';
}

export function kwApiUrl(path) {
  const segment = normalizePathSegment(path);

  if (import.meta.env.DEV) {
    return `${KW_API_BROWSER_PREFIX}/${segment}`;
  }

  const origin = getKwApiOrigin();
  return `${origin}${getKwApiPath()}/api/${segment}`;
}
